/** @jsx jsx */

import { ReactNode } from 'react';

import { Colors, Icon, TooltipWrapper } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  iconWrapper: css`
    align-items: center;
    border-radius: 100px;
    border: 1px solid ${Colors.PrimeBlack};
    display: flex;
    height: 60px;
    justify-content: center;
    width: 60px;
    margin: 'auto';
  `,
  popover: css`
    min-width: 120px;
    max-width: 300px;
    text-align: center;
  `,
};

export enum ButtonColor {
  primary = 'primary',
  secondary = 'secondary',
}

type Props = {
  hint: ReactNode;
};

function LockIcon({ hint }: Props) {
  return (
    <TooltipWrapper
      allowMultilineTooltip={true}
      content={<div css={Styles.popover}>{hint}</div>}
      isBlock={true}
      position="west"
    >
      {() => (
        <div aria-label="Locked" css={Styles.iconWrapper}>
          <Icon color="GrayWarm7" name="actionLockFill" size={32} />
        </div>
      )}
    </TooltipWrapper>
  );
}

export default LockIcon;
